<template>
  <div>
    <div class="OpenBetsPreview-styles-cashout-toggle">
      <span class="OpenBetsPreview-styles-cashout-label">Show only Cashout</span>
      <div class="" style="width: 35px;">
        <label class="Switch-styles-label">
          <input type="checkbox" class="Switch-styles-toggle-input" id="showOnlyCashout">
          <div class="Switch-styles-toggle-background"></div>
          <div class="Switch-styles-toggle-switch"></div>
        </label>
      </div>
    </div>
    <div class="OpenBetsPreview-styles-open-bets-preview">
      <div class="Paper-styles-paper OpenBetsPreview-styles-bet-item" v-for="b in bets">
        <div class="CollapsibleItem-styles-collapsible-item">
          <div class="MyBetsListItem-styles-bet-header MyBetsListItem-styles-bet-header-closed">
            <div class="MyBetsListItem-styles-bet-header-info">
              <div class="MyBetsListItem-styles-bet-header-date">{{ b.created_at | moment('D MMMM dddd HH:mm', session.timezone) }}</div>
              <div class="MyBetsListItem-styles-bet-header-type">{{ b.bet_count }} x {{ t[b.type.name] }}</div>
            </div>
            <div @click="openBet(b.id)" class="MyBetsListItem-styles-bet-header-status MyBetsListItem-styles-delivered">
              <span v-text="b.result.key == 'waiting' ? t.betting.waiting : b.result.key == 'win' ? t.betting.win : b.result.key == 'loss' ? t.betting.loss : t.betting.cancelled"></span>
            </div>
          </div>
          <div class="">
            <div class="Animation-styles-element" :style="(bet && bet.id === b.id) ? 'height: auto' : ''">
              <ul class="MyBetsListItem-styles-bet-list">
                <li class="MyBetsBetItem-styles-bet MyBetsBetItem-styles-desktop" v-for="item in items">
                  <router-link class="MyBetsBetItem-styles-bet-layout" :to="{name: 'SportsbookEvent', params: {event: item.mid} }">
                    <div class="MyBetsBetItem-styles-bet-market">
                      <span class="">{{ item.name }}: </span>
                      <span class="MyBetsBetItem-styles-bet-placed">{{ item.selection }}</span>
                    </div>
                    <div class="MyBetsBetItem-styles-bet-teams">{{ item.fcName }} - {{ item.scName }}</div>
                    <div class="MyBetsBetItem-styles-bet-details">
                      <span v-if="item.periodTime <= 0" class="MyBetsBetItem-styles-datetime">
                        {{ item.matchStartDate | moment('D MMMM dddd HH:mm', session.timezone) }}
                      </span>
                      <span v-if="item.periodTime > 0" class="MyBetsBetItem-styles-datetime">
                        {{ periodTimer(item) }}
                      </span>

                      <span v-if="!item.mData.score">&nbsp;</span>
                      <span class="MyBetsBetItem-styles-bet-result" v-else>
                        {{item.mData.score.home}} - {{item.mData.score.away}}
                      <span v-if="item.matchStats">
                        ( {{item.matchStats['1st half'].score.home}} - {{item.matchStats['1st half'].score.away}} )
                      </span>
                      </span>
                    </div>
                  </router-link>
                  <div class="MyBetsBetItem-styles-bet-quote MyBetsBetItem-styles-aligned">
                    {{ item.oddValue }}
                  </div>
                </li>
              </ul>
              <div class="MyBetsListItem-styles-bet-id">
                <div>Betslip ID: <span>{{ b.id }}</span>
                </div>
                <button @click="reuseBet(b.id)" class="Button-styles-button Button-styles-general Button-styles-icon Button-styles-icon-left MyBetsListItem-styles-reuse-betslip-button" name="reuseBetslip" title="Reuse">
                  <img src="/static/assets/img/reuse.svg" alt="myBets.site.reuseBetSlip">
                  <div class=""></div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <footer class="MyBetsListItem-styles-bet-footer undefined">
          <div>
            <span class="MyBetsListItem-styles-bet-footer-text">{{ t.betting.title.stake }}</span>
            <b>{{ b.amount | toMoney(session.currency) }}</b>
          </div>
          <div class="">
            <span class="MyBetsListItem-styles-bet-footer-text">{{ t.betting.title.possible_earnings }}</span>
            <b v-show="b.type.name !== 'System'">{{ b.earnings | toMoney(session.currency) }}</b>
            <b v-show="b.type.name === 'System'">{{ b.calculated_earnings | toMoney(session.currency) }}</b>
          </div>
        </footer>
      </div>
      <a href="/tr/myBets">
        <div class="OpenBetsPreview-styles-show-all-bets">Tüm Bahisler <span class="OpenBetsPreview-styles-arrow-right"></span>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import betSlip from "../../mixins/betSlip";
export default {
  name: 'openBets',
  mixins: [betSlip],
  data () {
    return {
      t: this.$root.t,
      session: window.session,
      bets: null,
      bet: null,
      items: null
    }
  },
  mounted() {
      this.fetchBets();
  },
  methods: {
    async fetchBets() {

      this.$http.get(api + 'api/v1/bets', {
        params: {
          //status: this.$route.query.status,
          status: 1,
          page: 1,
          per_page: 5,
          result: 1,
          sort: 'b.createdAt',
          direction: 'desc',
          bets: null,
          bet: null,
          items: null,
          fetching: null
        }
      })
          .then(response => {
            this.bets = response.body.result.bets;
            this.notfound = 0;
          }, response => {
            this.notfound = 1;
            this.bets = [];
          })
    },
    async fetchBet(id) {

      this.$http.get(bsapi + 'api/v1/bet/detail/' + id)
          .then(response => {
            this.fetching = false;
            this.bet = response.body.result.bet;
            this.items = response.body.result.items;
          }, response => {
            this.fetching = false;
          })

    },
    async openBet(id) {

      if(this.bet && this.bet.id === id){
        this.bet = null
        return false;
      }


      this.fetchBet(id)

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/widget/openBets.vue